/**
 * 独立版商品接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块
import VueCookies from 'vue-cookies';

const goodsAlone = {
    //独立版获取所有商品信息
    getAllGoodsInfoAlone(params) {
        // 门店登录时自动附加当前选中仓库id
        let userInfo = VueCookies.get('user');
        if (!userInfo) {
            let companyId = localStorage.getItem("companyId");
            userInfo = VueCookies.get('user_' + (companyId || ''));
        }
        if (userInfo && userInfo.custType == 4) {
            let whInfo = localStorage.getItem('warehouseInfo');
            if (whInfo) {
                let warehouseInfo = JSON.parse(whInfo);
                if (warehouseInfo.warehouseId) {
                    params.warehouseId = warehouseInfo.warehouseId;
                }
            }
        }
        return axios.post('/goods/mobileGoodsAlone/getAllGoodsInfoAlone', qs.stringify(params));
    },
    //手机前台根据商品id列表获取商品详细信息（独立版）
    getAllGoodsInfoAloneById(params) {
        return axios.post('/goods/mobileGoodsAlone/getAllGoodsInfoAloneById', qs.stringify(params));
    },
    //手机前台获取商品详情信息（独立版）
    getGoodsDetailAlone(params) {
        // 门店登录时自动附加当前选中仓库id
        let userInfo = VueCookies.get('user');
        if (!userInfo) {
            let companyId = localStorage.getItem("companyId");
            userInfo = VueCookies.get('user_' + (companyId || ''));
        }
        if (userInfo && userInfo.custType == 4) {
            let whInfo = localStorage.getItem('warehouseInfo');
            if (whInfo) {
                let warehouseInfo = JSON.parse(whInfo);
                if (warehouseInfo.warehouseId) {
                    params.warehouseId = warehouseInfo.warehouseId;
                }
            }
        }
        return axios.post('/goods/mobileGoodsAlone/getGoodsDetailAlone', qs.stringify(params));
    },
    //手机前台获取客户足迹商品信息（独立版）
    getUserHistoryGoodsInfo(params) {
        return axios.post('/goods/mobileGoodsAlone/getUserHistoryGoodsInfo', qs.stringify(params));
    },
    //获取活动列表信息
    getActivityList(params) {
        return axios.post('/goods/mobileActivityAlone/getActivityList', qs.stringify(params));
    },
    //通过活动id获取活动商品信息
    getActivityGoodsList(params) {
        // 门店登录时自动附加当前选中仓库id
        let userInfo = VueCookies.get('user');
        if (!userInfo) {
            let companyId = localStorage.getItem("companyId");
            userInfo = VueCookies.get('user_' + (companyId || ''));
        }
        if (userInfo && userInfo.custType == 4) {
            let whInfo = localStorage.getItem('warehouseInfo');
            if (whInfo) {
                let warehouseInfo = JSON.parse(whInfo);
                if (warehouseInfo.warehouseId) {
                    params.warehouseId = warehouseInfo.warehouseId;
                }
            }
        }
        return axios.post('/goods/mobileActivityAlone/getActivityGoodsList', qs.stringify(params));
    },
    //活动商品加入购物车
    addActivityGoodsBucket(params) {
        return axios.post('/goods/mobileActivityAlone/addActivityGoodsBucket', qs.stringify(params));
    },
    //组合套餐商品加入购物车
    addPackageActivityGoodsBucket(params) {
        // 门店登录时自动附加当前选中仓库id
        let userInfo = VueCookies.get('user');
        if (!userInfo) {
            let companyId = localStorage.getItem("companyId");
            userInfo = VueCookies.get('user_' + (companyId || ''));
        }
        if (userInfo && userInfo.custType == 4) {
            let whInfo = localStorage.getItem('warehouseInfo');
            if (whInfo) {
                let warehouseInfo = JSON.parse(whInfo);
                if (warehouseInfo.warehouseId) {
                    params.warehouseId = warehouseInfo.warehouseId;
                }
            }
        }
        return axios.post('/goods/mobileActivityAlone/addPackageActivityGoodsBucket', qs.stringify(params));
    },
    //手机前台获取商品包装所在所有组合套餐活动（独立版）
    getPackageActivityByGoodsPackId(params) {
        return axios.post('/goods/mobileGoodsAlone/getPackageActivityByGoodsPackId', qs.stringify(params));
    },
    //手机前台获取品牌汇列表信息（独立版）
    getBrandRemitListAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getBrandRemitListAlone', qs.stringify(params));
    },
    //获取品牌汇活动商品列表信息（独立版）
    getBrandRemitGoodsListAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getBrandRemitGoodsListAlone', qs.stringify(params));
    },
    //手机前台获取品牌汇详情信息（独立版）
    getMobileBrandRemitDetailAlone(params) {
        return axios.post('/goods/mobileBrandRemitAlone/getMobileBrandRemitDetailAlone', qs.stringify(params));
    },
    //获取商品促销活动列表信息
    getGoodsPromotionInfo(params) {
        return axios.post('/goods/mobileActivityAlone/getGoodsPromotionInfo', qs.stringify(params));
    },
    //获取商品促销活动所有商品信息
    getGoodsPromotionGoodsInfo(params) {
        return axios.post('/goods/mobileActivityAlone/getGoodsPromotionGoodsInfo', qs.stringify(params));
    },
    //手机前台首页获取商品推荐商品信息（独立版）
    getHomeRecommondGoodsAlone(params) {
        // 门店登录时自动附加当前选中仓库id
        let userInfo = VueCookies.get('user');
        if (!userInfo) {
            let companyId = localStorage.getItem("companyId");
            userInfo = VueCookies.get('user_' + (companyId || ''));
        }
        if (userInfo && userInfo.custType == 4) {
            let whInfo = localStorage.getItem('warehouseInfo');
            if (whInfo) {
                let warehouseInfo = JSON.parse(whInfo);
                if (warehouseInfo.warehouseId) {
                    params.warehouseId = warehouseInfo.warehouseId;
                }
            }
        }
        return axios.post('/goods/mobileGoodsAlone/getHomeRecommondGoodsAlone', qs.stringify(params));
    },
    //获取手机前台客户足迹页面商品（独立版）
    showUserHistoryGoodsAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/showUserHistoryGoodsAlone', qs.stringify(params));
    },
    //根据商品id获取退货商品列表信息
    getAllRefundGoodsInfoAloneById(params) {
        return axios.post('/order/mobileRefundAlone/getAllRefundGoodsInfoAloneById', qs.stringify(params));
    },
    //修改退货购物车数量
    changeRefundBucketNum(params) {
        return axios.post('/order/mobileRefundAlone/changeRefundBucketNum', qs.stringify(params));
    },
    //品牌
    getGoodsBrandInfo(params) {
        return axios.post('/goods/mobileGoodsAlone/getFpGoodsBrandListAlone', qs.stringify(params));
    },
    //获取智能报货商品信息接口
    getIntelligentGoodsInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/getIntelligentGoodsInfoAlone', qs.stringify(params));
    },
    batchAddBucketInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/batchAddBucketInfoAlone', qs.stringify(params));
    },
    //爆款单品
    getPopularGoodsInfoAlone(params) {
        return axios.post('/goods/mobileGoodsAlone/getPopularGoodsInfoAlone', qs.stringify(params));
    },
    //手机前台获取新品发布的商品（独立版）
    getNewProductLaunchGoodsInfoList (params) {
        return axios.post('/goods/mobileGoodsAlone/getNewProductLaunchGoodsInfoList ', qs.stringify(params));
    },
    //订货端获取满赠/满减/满赠活动信息（独立版）
    getFullReductionDiscountGiveActivityAloneInfoList(params) {
        return axios.post('/goods/full/getFullReductionDiscountGiveActivityAloneInfoList', qs.stringify(params));
    },
    //常用清单接口
    getCommonAloneList(params) {
        return axios.post('/goods/mobileGoodsAlone/getCommonAloneList', qs.stringify(params));
    },
    //手机前台活动商品减少购物车（独立版）接口
    updateActivityGoodsBucket(params) {
        return axios.post('/goods/mobileActivityAlone/updateActivityGoodsBucket', qs.stringify(params));
    },
    getOnlineIntelligentGoodsInfoAlone(params) {
        return axios.post('/goods/intelligentGoodsReportAlone/getOnlineIntelligentGoodsInfoAlone', qs.stringify(params));
    },
    // 秒杀活动商品模块集合接口
    getActivityBaseGoodsList(params) {
        return axios.post('/goods/mobileActivityAlone/getActivityBaseGoodsList', qs.stringify(params));
    },
    // 新增商品埋点记录（独立版）
    // trackType：1-详情浏览 2-加购 3-活动页浏览；activityType：1-特价 2-秒杀 3-满减/折/增
    addGoodsTrackRecord(params) {
        return axios.post('/goods/mobileGoodsAlone/addGoodsTrackRecord', qs.stringify(params));
    },
    // 活动页浏览埋点（trackType=3）；activityType：1-特价 2-秒杀 3-满减/折/增
    reportActivityPageTrack(userInfo, activityType) {
        if (!userInfo || !userInfo.companyId || !userInfo.userId || !activityType) {
            return Promise.resolve();
        }
        return this.addGoodsTrackRecord({
            companyId: userInfo.companyId,
            userId: userInfo.userId,
            activityType: activityType,
            trackType: 3
        }).catch(() => {});
    },
    // 商品详情浏览埋点（trackType=1）
    // goodsInfo 取详情接口返回字段
    reportGoodsDetailTrack(userInfo, goodsInfo) {
        if (!userInfo || !userInfo.companyId || !userInfo.userId || !goodsInfo) {
            return Promise.resolve();
        }
        const goodsId = typeof goodsInfo === 'object' ? goodsInfo.goodsId : goodsInfo;
        if (!goodsId) {
            return Promise.resolve();
        }
        const params = {
            companyId: userInfo.companyId,
            userId: userInfo.userId,
            goodsId: goodsId,
            trackType: 1
        };
        if (typeof goodsInfo === 'object') {
            if (goodsInfo.goodsTypeId != null && goodsInfo.goodsTypeId !== '') {
                params.goodsTypeId = goodsInfo.goodsTypeId;
            }
            if (goodsInfo.goodsBrandId != null && goodsInfo.goodsBrandId !== '') {
                params.goodsBrandId = goodsInfo.goodsBrandId;
            }
            if (goodsInfo.activityId != null && goodsInfo.activityId !== '') {
                params.activityId = goodsInfo.activityId;
            }
            if (goodsInfo.activityType != null && goodsInfo.activityType !== '') {
                params.activityType = goodsInfo.activityType;
            }
        }
        return this.addGoodsTrackRecord(params).catch(() => {});
    },
}

export default goodsAlone;


// WEBPACK FOOTER //
// ./src/request/api/goods/goods_alone.js